import {api} from './api';
import {IconTokens, StepperStateToken} from '@voltmoney/schema';
import {getLocalData, LocalStorageType} from './localStorage';
import {
  createNavigationContainerRef,
  NavigationContainerRefWithCurrent,
} from '@react-navigation/core';
import {ROUTE_PARTNER} from './types';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {PartnerLink, WhatsAppLink} from './constants';
import {UseNetworkPatch, UseNetworkPost} from '../utils/Network';
import {Platform} from 'react-native';

/** @description This shouldn't be used directly. It will affect globally **/
export const navigationRef: NavigationContainerRefWithCurrent<any> =
  createNavigationContainerRef();

export function navigateToPage(name: string, params?: object) {
  setTimeout(() => {
    if (navigationRef.isReady()) {
      navigationRef.navigate(name, params);
    }
  }, 250);
}

export enum RegexConfig {
  EMAIL = '^^[a-zA-Z0-9._{|}-]*@[a-zA-Z0-9]+.^[A-Za-z]+${2,}$',
  MOBILE = '^[0-9]*$',
  PAN = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$',
  AADHAR = '^[2-9]{1}[0-9]{11}$',
  NEW_MOBILE = '^[0-9]{10}$',
  NEW_EMAIL = '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$',
}

export const BreakPoints = {
  WEB: 1023,
};

export const partnerStepperItems = [
  {
    id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
    step: '1',
    title: 'Share unique referral link within clients, MFDs & IFAs',
    subTitle: '',
    horizontalTitle: '',
    status: StepperStateToken.COMPLETED,
    message: '',
    icon: IconTokens.GreenClipboard,
  },
  {
    id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
    step: '2',
    title: 'We’ll track your referrals and credit earnings',
    subTitle: '',
    horizontalTitle: '',
    status: StepperStateToken.COMPLETED,
    message: '',
    icon: IconTokens.GreenRupee,
  },
];

export const getUserContext = async () => {
  const response = await UseNetworkPost(
    `${api.partnerUserContext}`,
    {
      partnerAccountType: 'INDIVIDUAL',
    },
    {
      'X-AppPlatform': 'VOLT_WEB_APP',
      Authorization: `Bearer ${await getLocalData(
        LocalStorageType.ACCESS_TOKEN,
      )}`,
      'Content-Type': 'application/json',
    },
  );

  return response.data;
};

export const getUserContextWithRefCode = async (refCode: string) => {
  const response = await UseNetworkPost(
    `${api.partnerUserContext}`,
    {
      partnerAccountType: 'INDIVIDUAL',
      onboardingPartnerCode: refCode,
    },
    {
      'X-AppPlatform': 'VOLT_WEB_APP',
      Authorization: `Bearer ${await getLocalData(
        LocalStorageType.ACCESS_TOKEN,
      )}`,
      'Content-Type': 'application/json',
    },
  );

  return response.data;
};

export const updateUserContext = async (
  updatedObject: any,
  accountId: string,
) => {
  const response = await UseNetworkPatch(
    `${api.updatePartnerUserContext}${accountId}`,
    updatedObject,
    {
      'X-AppPlatform': 'VOLT_WEB_APP',
      Authorization: `Bearer ${await getLocalData(
        LocalStorageType.ACCESS_TOKEN,
      )}`,
      'Content-Type': 'application/json',
    },
  );

  return response.data;
};

export const handleWhatAppHelpLink = () => {
  window.open(`${WhatsAppLink.help}`, '_blank');
};

export const onLogout = async () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('USER_CONTEXT');
  localStorage.removeItem('ACCESS_TOKEN');
  window.open('/partner', '_self');
};

export const handleContactPhoneNumber = () => {
  window.open('tel:+919611749097', '_parent');
};

export const redirectToFaq = () => {
  window.open(`${PartnerLink}faq`, '_blank');
};

export const redirectToDashboard = async (query: string) => {
  await localStorage.setItem(LocalStorageType.DASHBOARD_ACTIVE_ID, query);
  await window.open(`${PartnerLink}${ROUTE_PARTNER.DASHBOARD_NEW}`, '_self');
  // await window.open(
  //   `http://localhost:3000/partner/${ROUTE_PARTNER.DASHBOARD_NEW}`,
  //   '_self',
  // );
};

export const addDaysToEpochTime = (epochTime: number, days: number) => {
  const date = new Date(epochTime);
  const dateAfterAddingDays = date.setDate(date.getDate() + days);
  return dateAfterAddingDays.valueOf();
};

export const PartnerRouteMap = (routeName: string) => {
  if (routeName === ROUTE_PARTNER.LEADS) {
    return ROUTE_PARTNER.LEADS;
  } else if (routeName === ROUTE_PARTNER.ACTIVE_CUSTOMER) {
    return ROUTE_PARTNER.ACTIVE_CUSTOMER;
  } else if (routeName === ROUTE_PARTNER.REFERRED_PARTNER) {
    return ROUTE_PARTNER.REFERRED_PARTNER;
  }
};

export const redirectTo = (url: string, target?: string) => {
  if (Platform.OS === 'web') {
    window.open(url, target ? target : '_self');
  }
};

export const getParameters: () => {
  [key in string]: string;
} = () => {
  const url = window.location.href;
  const params = {};
  const paramString = url.split('?')[1];
  const queryString = new URLSearchParams(paramString);
  //@ts-ignore
  for (const pair of queryString.entries()) {
    //@ts-ignore
    params[pair[0].includes('/') ? pair[0].split('/')[1] : pair[0]] =
      pair[1].includes('/') ? pair[1].split('/')[0] : pair[1];
  }
  return params;
};

export const isMobile = () => {
  const Breakpoint = 1024;
  if (Platform.OS === 'web') {
    if (window?.outerWidth < Breakpoint) {
      return true;
    } else {
      return false;
    }
  }
  return true;
};
